import { render, staticRenderFns } from "./compliance-insights-card.vue?vue&type=template&id=be41bc8a&"
import script from "./compliance-insights-card.vue?vue&type=script&lang=js&"
export * from "./compliance-insights-card.vue?vue&type=script&lang=js&"
import style0 from "./compliance-insights-card.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "compliance-insights-card.vue"
export default component.exports